import React, { Fragment, useEffect, useState } from 'react'
import NavBar from '../../../components/NavBar'
import ContestHeader from '../Header/ContestHeader'
import UserContestContent from '../UserContest/UserContest'
import qs from 'query-string'
import moment from 'moment'
import PropTypes from 'prop-types'

function UserContest (props) {
  // const excelRef = useRef()
  const [searchText, setSearchText] = useState('')
  const [initialFlag, setinitialFlag] = useState(false)
  const [openPicker, setOpenPicker] = useState(false)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [contestFilter, setContestFilter] = useState({ status: '', type: '' })

  const header = 'UC'

  useEffect(() => {
    const obj = qs.parse(props.location.search)
    setSearchText(obj.search || '')
    setContestFilter({ status: obj.cStatus || '', type: obj.cType || '' })
    if (obj.startDate && obj.endDate) {
      setStartDate(obj.startDate || startDate)
      setEndDate(obj.endDate || endDate)
    }
  }, [])

  function handleKeyPress (e) {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  function onHandleSearch (e) {
    setSearchText(e.target.value)
    setinitialFlag(true)
  }

  function onHandleDateRangePicker (isOpen = true, sd, ed) {
    setOpenPicker(isOpen)
    if (sd && ed) {
      setStartDate(moment(sd).format('DD MMM YYYY'))
      setEndDate(moment(ed).format('DD MMM YYYY'))
    } else {
      setStartDate('')
      setEndDate('')
    }
  }

  function onContestFilter (e, type) {
    switch (type) {
      case 'status':
        setContestFilter({ ...contestFilter, status: e.target.value })
        break

      case 'type':
        setContestFilter({ ...contestFilter, type: e.target.value })
        break
      default:
        setContestFilter({})
    }
  }

  return (
    <Fragment>
      <NavBar {...props}/>
      <main className='main-content'>
      <section className='management-section common-box'>
      <ContestHeader
      header={header}
      filter
      handleKeyPress={handleKeyPress}
      handleSearch={onHandleSearch}
      startDate={startDate}
      endDate={endDate}
      handleDateRangePicker={onHandleDateRangePicker}
      search={searchText}
      // handleExport={handleExport}
      contestFilter={contestFilter}
      onContestFilter={onContestFilter}
      />
      <UserContestContent
      {...props}
      flag={initialFlag}
      openPicker={openPicker}
      startDate={startDate}
      endDate={endDate}
      handleDateRangePicker={onHandleDateRangePicker}
      search={searchText}
      contestFilter={contestFilter}
      />
      </section>
      </main>
    </Fragment>
  )
}

UserContest.propTypes = {
  location: PropTypes.object
}
export default UserContest
